<template>
  <div class="bg-[#f8f8f8]">
    <div class="lg:px-8">
      <div class="max-w-7xl m-auto lg:py-7">
        <div class="flex items-center justify-center px-5 md:px-0">
          <div class="flex-grow border-t-2 border-black"></div>
          <h2
            class="px-4 text-[21px] uppercase lg:text-3xl text-[#001c54] font-semibold text-center mt-4 mb-4"
          >
            OUR ALUMNI
          </h2>
          <div class="flex-grow border-t-2 border-black"></div>
        </div>

        <div class="relative">
          <div
            class="absolute bottom-0 right-0 top-[150px] md:top-[40%] md:right-0 z-10 cursor-pointer"
          >
            <img
              src="@/assets/MbaFinance/right-arrow.png"
              class="nextour w-[30px] h-[30px]"
              width="30px"
              height="40px"
              alt=""
            />
          </div>
          <div class="gap-5 aluminai md:flex max-w-6xl mx-auto">
            <div
              class="!w-[286px] flex flex-col mx-auto items-center justify-center m-2 p-2 rounded-md"
            >
              <div class="flex justify-center ouralumniBG3">
                <img
                  src="@/assets/LPnew/images/alumni/alumni_img1.png"
                  alt="NAAC"
                  loading="lazy"
                  decoding="async"
                  class="object-contain"
                />
              </div>
              <h2 class="text-[15px] lg:text-md pt-2 text-[#001c54]">
                NANDAN SHARMA
              </h2>
              <div>
                <img
                  src="@/assets/LPnew/images/alumni/comp_img1.png"
                  alt=""
                  class="w-[115px] h-[60px] mx-auto"
                />
              </div>
            </div>
            <div
              class="!w-[286px] flex flex-col items-center justify-center m-2 p-2 rounded-md"
            >
              <div class="flex justify-center">
                <img
                  src="@/assets/LPnew/images/alumni/alumni_img2.png"
                  alt="NAAC"
                  loading="lazy"
                  decoding="async"
                  class="object-contain"
                />
              </div>
              <h2 class="text-[15px] lg:text-md pt-2 text-[#001c54]">
                VISMAYA MENON
              </h2>
              <div>
                <img
                  src="@/assets/LPnew/images/alumni/comp_img2.png"
                  alt=""
                  class="w-[115px] h-[60px] mx-auto"
                />
              </div>
            </div>
            <div
              class="!w-[286px] flex flex-col items-center justify-center m-2 p-2 rounded-md"
            >
              <div class="flex justify-center">
                <img
                  src="@/assets/LPnew/images/alumni/alumni_img3.png"
                  alt="NAAC"
                  loading="lazy"
                  decoding="async"
                  class="object-contain"
                />
              </div>
              <h2 class="text-[15px] lg:text-md pt-2 text-[#001c54]">
                AMBIKAISHWARYA K
              </h2>
              <div>
                <img
                  src="@/assets/LPnew/images/alumni/comp_img3.png"
                  alt=""
                  class="w-[115px] h-[60px] mx-auto"
                />
              </div>
            </div>
            <div
              class="!w-[286px] flex flex-col items-center justify-center m-2 p-2 rounded-md"
            >
              <div class="flex justify-center">
                <img
                  src="@/assets/LPnew/images/alumni/alumni_img4.png"
                  alt="NAAC"
                  loading="lazy"
                  decoding="async"
                  class="object-contain"
                />
              </div>
              <h2 class="text-[15px] lg:text-md pt-2 text-[#001c54]">
                MILAN KOTHARI
              </h2>
              <div>
                <img
                  src="@/assets/LPnew/images/alumni/comp_img4.png"
                  alt=""
                  class="w-[115px] h-[60px] mx-auto"
                />
              </div>
            </div>

            <div
              class="!w-[286px] flex flex-col items-center justify-center m-2 p-2 rounded-md"
            >
              <div class="flex justify-center">
                <img
                  src="@/assets/LPnew/images/alumni/alumni_img5.png"
                  alt="NAAC"
                  loading="lazy"
                  decoding="async"
                  class="object-contain"
                />
              </div>
              <h2 class="text-[15px] lg:text-md pt-2 text-[#001c54]">
                SHREYAS S RANGA
              </h2>
              <div>
                <img
                  src="@/assets/LPnew/images/alumni/comp_img5.png"
                  alt=""
                  class="w-[115px] h-[60px] mx-auto"
                />
              </div>
            </div>
            <div
              class="!w-[286px] flex flex-col items-center justify-center m-2 p-2 rounded-md"
            >
              <div class="flex justify-center">
                <img
                  src="@/assets/LPnew/images/alumni/alumni_img6.png"
                  alt="NAAC"
                  loading="lazy"
                  decoding="async"
                  class="object-contain"
                />
              </div>
              <h2 class="text-[15px] lg:text-md pt-2 text-[#001c54]">
                DUNHIL FERNANDES
              </h2>
              <div>
                <img
                  src="@/assets/LPnew/images/alumni/comp_img6.png"
                  alt=""
                  class="w-[115px] h-[60px] mx-auto"
                />
              </div>
            </div>

            <div
              class="!w-[286px] flex flex-col items-center justify-center m-2 p-2 rounded-md"
            >
              <div class="flex justify-center">
                <img
                  src="@/assets/LPnew/images/alumni/alumni_img7.png"
                  alt="NAAC"
                  loading="lazy"
                  decoding="async"
                  class="object-contain"
                />
              </div>
              <h2 class="text-[15px] lg:text-md pt-2 text-[#001c54]">
                ARPITA HAZARIKA
              </h2>
              <div>
                <img
                  src="@/assets/LPnew/images/alumni/comp_img7.png"
                  alt=""
                  class="w-[115px] h-[60px] mx-auto"
                />
              </div>
            </div>
            <div
              class="!w-[286px] flex flex-col items-center justify-center m-2 p-2 rounded-md"
            >
              <div class="flex justify-center">
                <img
                  src="@/assets/LPnew/images/alumni/alumni_img8.png"
                  alt="NAAC"
                  loading="lazy"
                  decoding="async"
                  class="object-contain"
                />
              </div>
              <h2 class="text-[15px] lg:text-md pt-2 text-[#001c54]">
                VISMAYA MENONN
              </h2>
              <div>
                <img
                  src="@/assets/LPnew/images/alumni/comp_img8.png"
                  alt=""
                  class="w-[115px] h-[60px] mx-auto"
                />
              </div>
            </div>
          </div>
          <div
            class="absolute bottom-0 left-0 top-[150px] md:top-[40%] z-10 cursor-pointer"
          >
            <img
              src="@/assets/MbaFinance/left-arrow.png"
              width="30px"
              height="40px"
              class="prevour"
              alt=""
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import $ from "jquery";
import "slick-carousel";
export default {
  name: "OurAluminai",
  mounted() {
    $(`.aluminai`).slick({
      autoplay: true,
      prevArrow: $(".prevour"),
      nextArrow: $(".nextour"),
      slidesToShow: 4,
      slidesToScroll: 1,
      dots: false,
      dotsClass: "slick-dots",

      responsive: [
        {
          breakpoint: 1026,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 4,
          },
        },
        {
          breakpoint: 950,
          settings: {
            slidesToShow: 4,
            slidesToScroll: 4,
          },
        },
        {
          breakpoint: 650,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
      ],
    });
  },
};
</script>

<style scoped></style>
